import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { RoutesList } from "@/router/routesList";
import { useCreateCityMutation } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { CityEditForm } from "./components/CityEditForm";
import { convertToCreateDto } from "./mappers/convertToCreateDto";
import { getEmptyCity } from "./mappers/getEmptyCity";
export var CityCreatePage = function () {
    var _a = useCreateCityMutation(), cityCreateAction = _a[0], cityCreateState = _a[1];
    var saveFormHandler = function (data) {
        try {
            cityCreateAction({
                createCityDto: convertToCreateDto(data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var cancelFormHandler = function () {
        navigate(RoutesList.Manage.getCitiesList());
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (cityCreateState.isSuccess) {
            navigate(RoutesList.Manage.getCitiesList());
        }
    }, [cityCreateState.isSuccess]);
    useSetPageData({ title: "Город" });
    return (_jsx(CityEditForm, { isCreate: true, data: getEmptyCity(), onSave: saveFormHandler, onCancel: cancelFormHandler }));
};
